const BASE = process.env.REACT_APP_BACKEND_URL || "";
function token() { return localStorage.getItem("sanber_token") || ""; }
async function req(path, opts = {}) {
  const headers = opts.headers || {};
  if (!(opts.body instanceof FormData)) headers["Content-Type"] = "application/json";
  if (token()) headers["Authorization"] = "Bearer " + token();
  const method = (opts.method || "GET").toUpperCase();
  let res;
  try {
    res = await fetch(BASE + path, { ...opts, headers });
  } catch (netErr) {
    // Network-level failure (server waking from idle, dropped connection, or offline) —
    // fetch() itself rejected, so no HTTP response was received.
    if (method === "GET") {
      // Reads are safe to retry: the server may just be waking up.
      await new Promise(r => setTimeout(r, 1200));
      try { res = await fetch(BASE + path, { ...opts, headers }); }
      catch (e2) { throw new Error("Can't reach the server (it may be waking up or your connection dropped). Please try again in a moment."); }
    } else {
      // Don't auto-retry writes (could duplicate) — tell the user to retry.
      throw new Error("The server didn't respond (it may be waking up, or your connection dropped). Please click Save again — your data was not lost.");
    }
  }
  if (!res.ok) {
    // Read the error body BEFORE any redirect, otherwise a page navigation aborts the body read
    // and the real server message (e.g. "Invalid username or password") is lost.
    const e = await res.json().catch(() => ({}));
    const msg = e.detail || "Request failed";
    // A 401 on the login call is just a bad credential — show the message, don't bounce the page.
    // A 401 on any other call means the session expired: clear it and return to the login screen.
    if (res.status === 401 && path !== "/api/auth/login") { localStorage.removeItem("sanber_token"); window.location.href = "/login"; }
    if (res.status === 409) { try { window.alert(msg); } catch (_) {} }
    throw new Error(msg);
  }
  return res.status === 204 ? null : res.json();
}
export const api = {
  login: (b) => req("/api/auth/login", { method: "POST", body: JSON.stringify(b) }),
  me: () => req("/api/auth/me"),
  meta: () => req("/api/meta"),
  dashboard: () => req("/api/dashboard"),
  users: () => req("/api/users"),
  createUser: (b) => req("/api/users", { method: "POST", body: JSON.stringify(b) }),
  updateUser: (id, b) => req("/api/users/" + id, { method: "PUT", body: JSON.stringify(b) }),
  deleteUser: (id) => req("/api/users/" + id, { method: "DELETE" }),
  uploadSig: (id, fd) => req("/api/users/" + id + "/signature", { method: "POST", body: fd }),
  roles: () => req("/api/roles"),
  createRole: (b) => req("/api/roles", { method: "POST", body: JSON.stringify(b) }),
  updateRole: (id, b) => req("/api/roles/" + id, { method: "PUT", body: JSON.stringify(b) }),
  deleteRole: (id) => req("/api/roles/" + id, { method: "DELETE" }),
  ensureStandardRoles: () => req("/api/roles/ensure-standard", { method: "POST" }),
  master: (k) => req("/api/masters/" + k),
  masterPublic: (k) => req("/api/masters-public/" + k),
  addMaster: (b) => req("/api/masters", { method: "POST", body: JSON.stringify(b) }),
  editMaster: (id, b) => req("/api/masters/" + id, { method: "PUT", body: JSON.stringify(b) }),
  delMaster: (id) => req("/api/masters/" + id, { method: "DELETE" }),
  personnel: () => req("/api/personnel"),
  personnelPublic: () => req("/api/personnel-public"),
  addPersonnel: (b) => req("/api/personnel", { method: "POST", body: JSON.stringify(b) }),
  editPersonnel: (id, b) => req("/api/personnel/" + id, { method: "PUT", body: JSON.stringify(b) }),
  delPersonnel: (id) => req("/api/personnel/" + id, { method: "DELETE" }),
  signatories: () => req("/api/signatories"),
  signatoriesPublic: () => req("/api/signatories-public"),
  addSignatory: (b) => req("/api/signatories", { method: "POST", body: JSON.stringify(b) }),
  editSignatory: (id, b) => req("/api/signatories/" + id, { method: "PUT", body: JSON.stringify(b) }),
  delSignatory: (id) => req("/api/signatories/" + id, { method: "DELETE" }),
  documents: () => req("/api/documents"),
  document: (k) => req("/api/documents/" + k),
  versions: (k) => req("/api/documents/" + k + "/versions"),
  newVersion: (k, b) => req("/api/documents/" + k + "/new-version", { method: "POST", body: JSON.stringify(b) }),
  revertVersion: (k, version_id) => req("/api/documents/" + k + "/revert", { method: "POST", body: JSON.stringify({ version_id }) }),
  setAmendments: (k, amendments) => req("/api/documents/" + k + "/amendments", { method: "PUT", body: JSON.stringify({ amendments }) }),
  setDocHeader: (k, header) => req("/api/documents/" + k + "/header", { method: "PUT", body: JSON.stringify(header) }),
  setDocPages: (k, pages) => req("/api/documents/" + k + "/pages", { method: "PUT", body: JSON.stringify({ pages }) }),
  company: () => req("/api/company"),
  companyLogo: () => req("/api/company-logo"),
  saveCompany: (b) => req("/api/company", { method: "PUT", body: JSON.stringify(b) }),
  org: () => req("/api/org-chart"),
  saveOrg: (b) => req("/api/org-chart", { method: "PUT", body: JSON.stringify(b) }),
  backups: () => req("/api/backups"),
  runBackup: () => req("/api/backup", { method: "POST" }),
  restore: (fd) => req("/api/restore", { method: "POST", body: fd }),
  downloadBackup: (id) => req("/api/backups/" + id + "/download"),
  downloadBackupBlob: async (id) => {
    const res = await fetch(BASE + "/api/backups/" + id + "/download", { headers: token() ? { Authorization: "Bearer " + token() } : {} });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error((e && e.detail) || "Request failed"); }
    return res.blob();
  },
  deleteBackup: (id) => req("/api/backups/" + id, { method: "DELETE" }),
  uploadFile: (fd) => req("/api/files", { method: "POST", body: fd }),
  migrateFiles: () => req("/api/admin/migrate-files", { method: "POST" }),
  fileUrl: (f) => (f && f.file_id) ? (BASE + "/api/files/" + f.file_id + "?token=" + encodeURIComponent(token())) : ((f && f.data) || ""),
  c4List: (coll) => req("/api/c4/" + coll),
  c4Add: (coll, b) => req("/api/c4/" + coll, { method: "POST", body: JSON.stringify(b) }),
  c4Edit: (coll, id, b, correction) => req("/api/c4/" + coll + "/" + id + (correction ? "?correction=true" : ""), { method: "PUT", body: JSON.stringify(b) }),
  c4Del: (coll, id) => req("/api/c4/" + coll + "/" + id, { method: "DELETE" }),
  c4Attach: (coll, id, field, ref) => req("/api/c4/" + coll + "/" + id + "/attach", { method: "POST", body: JSON.stringify({ field, ref }) }),
  c4Detach: (coll, id, field, index) => req("/api/c4/" + coll + "/" + id + "/detach", { method: "POST", body: JSON.stringify({ field, index }) }),
  c4SetField: (coll, id, field, value) => req("/api/c4/" + coll + "/" + id + "/setfield", { method: "POST", body: JSON.stringify({ field, value }) }),
  c4SelfDel: (coll, id) => req("/api/c4/" + coll + "/" + id + "/selfdelete", { method: "POST" }),
  c4Bulk: (coll, rows) => req("/api/c4/" + coll + "/bulk", { method: "POST", body: JSON.stringify({ rows }) }),
  calibrationAlerts: () => req("/api/calibration-alerts"),
  auditLog: () => req("/api/audit-log"),
  auditLogPage: (skip, limit) => req("/api/audit-log?skip=" + skip + "&limit=" + limit),
  c4Page: (coll, skip, limit) => req("/api/c4/" + coll + "?skip=" + skip + "&limit=" + limit),
  readiness: () => req("/api/readiness"),
  iqcScope: () => req("/api/c4/iqc_scope_parameters"),
  addIqcParam: (b) => req("/api/c4/iqc_scope_parameters", { method: "POST", body: JSON.stringify(b) }),
  editIqcParam: (id, b) => req("/api/c4/iqc_scope_parameters/" + id, { method: "PUT", body: JSON.stringify(b) }),
  delIqcParam: (id) => req("/api/c4/iqc_scope_parameters/" + id, { method: "DELETE" }),
  iqcPlan: (activity, year) => req("/api/iqc/plan?activity=" + activity + "&year=" + (year || 2026)),
  saveIqcPlan: (b) => req("/api/iqc/plan", { method: "PUT", body: JSON.stringify(b) }),
  iqcStatus: (year) => req("/api/iqc/status?year=" + (year || 2026)),
  importDoc: (k, fd) => req("/api/documents/" + k + "/import", { method: "POST", body: fd }),
  recycleBin: () => req("/api/recycle-bin"),
  recycleRestore: (entry_id) => req("/api/recycle-bin/restore", { method: "POST", body: JSON.stringify({ entry_id }) }),
  recordHistory: (coll, id) => req("/api/c4/" + coll + "/" + id + "/history"),
  c4Approve: (coll, id, stage) => req("/api/c4/" + coll + "/" + id + "/approve", { method: "POST", body: JSON.stringify({ stage }) }),
  c4Reopen: (coll, id) => req("/api/c4/" + coll + "/" + id + "/reopen", { method: "POST" }),
  changePassword: (b) => req("/api/auth/change-password", { method: "POST", body: JSON.stringify(b) }),
  fieldGaps: () => req("/api/field-gaps"),
  compliance: () => req("/api/compliance"),
  aiChat: (messages) => req("/api/ai/chat", { method: "POST", body: JSON.stringify({ messages }) }),
  notifications: (qs) => req("/api/notifications" + (qs ? "?" + qs : "")),
  notifUnread: () => req("/api/notifications/unread-count"),
  notifSummary: (scope) => req("/api/notifications/summary" + (scope ? "?scope=" + scope : "")),
  notifRead: (id) => req("/api/notifications/" + id + "/read", { method: "PATCH" }),
  notifReadAll: () => req("/api/notifications/read-all", { method: "POST" }),
  notifResolve: (id) => req("/api/notifications/" + id + "/resolve", { method: "PATCH" }),
  notifRunScan: () => req("/api/notifications/run-scan", { method: "POST" }),
  acceptedFormats: () => req("/api/settings/accepted-formats"),
  setAcceptedFormat: (code, accepted) => req("/api/settings/accepted-formats", { method: "POST", body: JSON.stringify({ code, accepted }) }),
};
